import React from 'react'

import ContentLoader from 'react-content-loader'

import { darkModeVar } from '@web/hooks/useGlobalDetermineDarkMode'
import { useGlobalStaticStateContext } from '@web/hooks/useGlobalStaticState'
import { generateRandomKey } from '@web/libs/utils'

interface LoaderRectStyle {
  width: number
  height: number
  margin: number
  radius: number
  rows: number
  cols: number
}

const REVIEW_TAB: LoaderRectStyle = {
  width: 160,
  height: 192,
  margin: 5,
  radius: 6,
  rows: 3,
  cols: 2,
}

const REVIEW_TAB_WIDE: LoaderRectStyle = {
  width: 102,
  height: 127,
  margin: 5,
  radius: 6,
  rows: 3,
  cols: 3,
}

const MAX_WIDTH = 415

interface RowProps {
  rowIndex: number
}

const Row = ({ rowIndex }: RowProps) => {
  const rectStyles = window.innerWidth < MAX_WIDTH ? REVIEW_TAB : REVIEW_TAB_WIDE
  return (
    <>
      {new Array(rectStyles.cols).fill(null).map((_, idx) => (
        <rect
          key={generateRandomKey()}
          x={(rectStyles.width + rectStyles.margin) * idx}
          y={(rectStyles.height + rectStyles.margin) * rowIndex}
          rx={rectStyles.radius}
          ry={rectStyles.radius}
          width={rectStyles.width}
          height={rectStyles.height}
        />
      ))}
    </>
  )
}

interface Props {
  margin?: string
}

const ViewGridImageLoader: React.FC<Props> = ({ margin = '' }) => {
  const dark = darkModeVar()
  const { isSsr } = useGlobalStaticStateContext()

  if (isSsr) return null

  const currentUrl = window.location.href
  const rectStyles = window.innerWidth < MAX_WIDTH ? REVIEW_TAB : REVIEW_TAB_WIDE

  const width = rectStyles.width * rectStyles.cols + rectStyles.margin * (rectStyles.cols - 1)
  const height = rectStyles.height * rectStyles.rows + rectStyles.margin * (rectStyles.rows - 1)

  return (
    <div style={{ margin }}>
      <ContentLoader
        viewBox={`0 0 ${width} ${height}`}
        speed={2}
        baseUrl={currentUrl}
        backgroundColor={dark ? '#3f3f43' : '#e9eff2'}
        foregroundColor={dark ? '#464649' : '#f2f4f6'}
      >
        {new Array(rectStyles.rows).fill(Row).map((item, index) =>
          React.createElement(item, {
            // eslint-disable-next-line
            key: index,
            rowIndex: index,
          }),
        )}
      </ContentLoader>
    </div>
  )
}

export default ViewGridImageLoader
